// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type Aufgabe } from "../../api";
import { useGetAufgabe as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useAufgabeQueryKey(aufgabeId: string): QueryKey {
  return ["api", "v1", "aufgaben", aufgabeId];
}

export function useAufgabe(
  aufgabeId: string,
  options: Omit<UseQueryOptions<Aufgabe, ApiError>, "queryKey" | "queryFn"> = {}
): Aufgabe {
  const getter = useGetter();
  return useQuery(
    useAufgabeQueryKey(aufgabeId),
    () => getter(aufgabeId),
    options
  ).data!;
}
